import type { ResampledLap } from '@tla/types';

/**
 * Compute the cumulative time delta between a target lap and a reference lap on a
 * shared distance grid. Positive values mean the target is slower (has lost time)
 * relative to the reference at that point on track.
 *
 * Both laps must be resampled onto the same distance grid (same length).
 */
export function deltaTime(reference: ResampledLap, target: ResampledLap): Float64Array {
  const n = Math.min(reference.time.length, target.time.length);
  const out = new Float64Array(n);
  for (let i = 0; i < n; i++) {
    out[i] = target.time[i] - reference.time[i];
  }
  return out;
}
